var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 18,
    viewBox: "0 0 55 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3823",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 1,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.746 1.0001C46.6658 1.0001 46.038 1.41299 45.6192 2.39905C43.6852 6.95157 41.7509 11.5041 39.8177 16.0569C39.5474 16.6933 39.2812 17.3313 39 17.9996C40.5428 17.9996 42.0424 18.0029 43.5418 17.99C43.6207 17.9894 43.7361 17.865 43.7709 17.7745C44.0273 17.1072 44.278 16.4372 44.5071 15.7603C44.5837 15.5339 44.6838 15.4518 44.9356 15.4538C46.5991 15.4669 48.2631 15.4721 49.9264 15.4509C50.2597 15.4467 50.3552 15.5609 50.4086 15.8558C50.5371 16.566 50.6999 17.2704 50.8516 17.9903H55V17.8694C54.866 17.2956 54.7219 16.7237 54.5997 16.1474C53.646 11.6488 52.697 7.14918 51.7455 2.65005C51.6297 2.10198 51.5084 1.555 51.3881 1.0001C50.5651 1.0001 49.7557 1 48.951 1C48.5486 1 48.1472 1.0001 47.746 1.0001ZM48.2028 5.72233C48.2206 5.72575 48.2385 5.72916 48.2562 5.73257C48.6924 7.79662 49.1286 9.86056 49.5707 11.9526H45.9144C46.6828 9.86056 47.4428 7.7914 48.2028 5.72233Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3823)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.746 1.0001C46.6658 1.0001 46.038 1.41299 45.6192 2.39905V2.39905C43.6852 6.95157 41.7509 11.5041 39.8177 16.0569V16.0569C39.5474 16.6933 39.2812 17.3313 39 17.9996V17.9996C40.5428 17.9996 42.0424 18.0029 43.5418 17.99V17.99C43.6207 17.9894 43.7361 17.865 43.7709 17.7745V17.7745C44.0273 17.1072 44.278 16.4372 44.5071 15.7603V15.7603C44.5837 15.5339 44.6838 15.4518 44.9356 15.4538V15.4538C46.5991 15.4669 48.2631 15.4721 49.9264 15.4509V15.4509C50.2597 15.4467 50.3552 15.5609 50.4086 15.8558V15.8558C50.5371 16.566 50.6999 17.2704 50.8516 17.9903V17.9903H55V17.8694C54.866 17.2956 54.7219 16.7237 54.5997 16.1474V16.1474C53.646 11.6488 52.697 7.14918 51.7455 2.65005V2.65005C51.6297 2.10198 51.5084 1.555 51.3881 1.0001V1.0001C50.5651 1.0001 49.7557 1 48.951 1V1C48.5486 1 48.1472 1.0001 47.746 1.0001M48.2028 5.72233C48.2206 5.72575 48.2385 5.72916 48.2562 5.73257V5.73257C48.6924 7.79662 49.1286 9.86056 49.5707 11.9526V11.9526H45.9144C46.6828 9.86056 47.4428 7.7914 48.2028 5.72233",
    fill: "url(#paint0_linear_0_3823)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_3823",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 0,
    width: 13,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9826 0C35.9003 0.0209685 35.8192 0.051085 35.7356 0.061672C34.2328 0.253472 32.8221 0.71005 31.634 1.73874C30.2683 2.92109 29.6082 4.44275 29.7996 6.31675C29.9274 7.56839 30.6013 8.51002 31.5319 9.21626C32.258 9.7672 33.0729 10.1868 33.8401 10.6791C34.3313 10.9943 34.8495 11.2843 35.2806 11.677C35.9364 12.2745 35.8674 13.2304 35.1471 13.7391C34.815 13.9735 34.4157 14.1557 34.0241 14.2329C32.5188 14.5299 31.0665 14.2569 29.66 13.66C29.3658 13.5351 29.0776 13.3935 28.7708 13.2524C28.509 14.5439 28.2544 15.8003 28 17.0547C28.0539 17.09 28.0845 17.1168 28.1195 17.1319C28.2371 17.1826 28.3547 17.2347 28.4754 17.2765C29.8654 17.7575 31.2831 17.9997 32.7244 18H32.7327C33.1552 17.9998 33.5797 17.9789 34.0061 17.9371C35.3555 17.8048 36.6503 17.4476 37.7945 16.6479C39.6142 15.3763 40.4154 13.5788 40.1453 11.2969C39.9927 10.0067 39.2657 9.05232 38.2688 8.3583C37.4223 7.76892 36.5078 7.28912 35.6368 6.73736C35.2537 6.49458 34.8703 6.23124 34.5469 5.91034C34.0777 5.44492 34.0843 4.80682 34.5756 4.3635C34.8618 4.10499 35.2299 3.90003 35.5937 3.79324C36.4883 3.53052 37.4049 3.60987 38.2991 3.81791C38.9531 3.96983 39.5892 4.20665 40.2547 4.41212C40.4976 3.21609 40.7457 1.99365 41 0.740989C40.4955 0.589687 40.0309 0.428929 39.5561 0.313602C39.036 0.187174 38.5067 0.102684 37.9813 0H35.9826Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_3823)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9826 0C35.9003 0.0209685 35.8192 0.051085 35.7356 0.061672V0.061672C34.2328 0.253472 32.8221 0.71005 31.634 1.73874V1.73874C30.2683 2.92109 29.6082 4.44275 29.7996 6.31675V6.31675C29.9274 7.56839 30.6013 8.51002 31.5319 9.21626V9.21626C32.258 9.7672 33.0729 10.1868 33.8401 10.6791V10.6791C34.3313 10.9943 34.8495 11.2843 35.2806 11.677V11.677C35.9364 12.2745 35.8674 13.2304 35.1471 13.7391V13.7391C34.815 13.9735 34.4157 14.1557 34.0241 14.2329V14.2329C32.5188 14.5299 31.0665 14.2569 29.66 13.66V13.66C29.3658 13.5351 29.0776 13.3935 28.7708 13.2524V13.2524C28.509 14.5439 28.2544 15.8003 28 17.0547V17.0547C28.0539 17.09 28.0845 17.1168 28.1195 17.1319V17.1319C28.2371 17.1826 28.3547 17.2347 28.4754 17.2765V17.2765C29.8654 17.7575 31.2831 17.9997 32.7244 18V18H32.7327C33.1552 17.9998 33.5797 17.9789 34.0061 17.9371V17.9371C35.3555 17.8048 36.6503 17.4476 37.7945 16.6479V16.6479C39.6142 15.3763 40.4154 13.5788 40.1453 11.2969V11.2969C39.9927 10.0067 39.2657 9.05232 38.2688 8.3583V8.3583C37.4223 7.76892 36.5078 7.28912 35.6368 6.73736V6.73736C35.2537 6.49458 34.8703 6.23124 34.5469 5.91034V5.91034C34.0777 5.44492 34.0843 4.80682 34.5756 4.3635V4.3635C34.8618 4.10499 35.2299 3.90003 35.5937 3.79324V3.79324C36.4883 3.53052 37.4049 3.60987 38.2991 3.81791V3.81791C38.9531 3.96983 39.5892 4.20665 40.2547 4.41212V4.41212C40.4976 3.21609 40.7457 1.99365 41 0.740989V0.740989C40.4955 0.589687 40.0309 0.428929 39.5561 0.313602V0.313602C39.036 0.187174 38.5067 0.102684 37.9813 0V0H35.9826Z",
    fill: "url(#paint1_linear_0_3823)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_3823",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 21,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1752 1.26574C14.7111 4.92208 13.2391 8.57531 11.7675 12.2289C11.7395 12.2984 11.6966 12.3621 11.6352 12.4754C11.5959 12.285 11.5662 12.1504 11.5402 12.0152C10.9461 8.92288 10.3574 5.82962 9.75589 2.73867C9.5435 1.64681 8.73221 1.00602 7.60842 1.00572C5.23904 1.00491 2.86967 1.00552 0.500396 1.00552C0.00664061 1.00552 0.00664062 1.00552 0 1.51494C0.0550661 1.52848 0.113504 1.54352 0.172248 1.55716C1.49894 1.86643 2.79948 2.24679 4.05241 2.78831C4.83407 3.12625 5.25079 3.67679 5.459 4.48275C6.59373 8.87635 7.76064 13.262 8.90835 17.6522C8.97445 17.905 9.06803 18.0038 9.35511 17.9999C10.7087 17.9814 12.0628 17.9858 13.4166 17.997C13.6641 17.9989 13.7886 17.9361 13.8903 17.6966C16.0267 12.6701 18.1745 7.64841 20.3195 2.62565C20.5441 2.09958 20.7657 1.5723 21 1.01935C20.8742 1.01354 20.7854 1.00592 20.6966 1.00592C20.3077 1.00582 19.9189 1.00602 19.5301 1.00632C18.5444 1.00702 17.5587 1.00772 16.5732 1.0001C16.5703 1.0001 16.5675 1 16.5648 1C16.3511 1 16.2541 1.06859 16.1752 1.26574Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_3823)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1752 1.26574C14.7111 4.92208 13.2391 8.57531 11.7675 12.2289V12.2289C11.7395 12.2984 11.6966 12.3621 11.6352 12.4754V12.4754C11.5959 12.285 11.5662 12.1504 11.5402 12.0152V12.0152C10.9461 8.92288 10.3574 5.82962 9.75589 2.73867V2.73867C9.54349 1.64681 8.73222 1.00602 7.60842 1.00572V1.00572C5.23904 1.00491 2.86967 1.00552 0.500396 1.00552V1.00552C0.00664061 1.00552 0.00664062 1.00552 0 1.51494V1.51494C0.0550661 1.52848 0.113504 1.54352 0.172248 1.55716V1.55716C1.49894 1.86643 2.79948 2.24679 4.05241 2.78831V2.78831C4.83407 3.12625 5.25079 3.67679 5.459 4.48275V4.48275C6.59373 8.87635 7.76064 13.262 8.90835 17.6522V17.6522C8.97444 17.905 9.06803 18.0038 9.35511 17.9999V17.9999C10.7087 17.9814 12.0628 17.9858 13.4166 17.997V17.997C13.6641 17.9989 13.7886 17.9361 13.8903 17.6966V17.6966C16.0267 12.6701 18.1745 7.64841 20.3195 2.62565V2.62565C20.5441 2.09958 20.7657 1.5723 21 1.01935V1.01935C20.8742 1.01354 20.7854 1.00592 20.6966 1.00592V1.00592C20.3077 1.00582 19.9189 1.00602 19.5301 1.00632V1.00632C18.5444 1.00702 17.5587 1.00772 16.5732 1.0001V1.0001C16.5703 1.0001 16.5675 1 16.5648 1V1C16.3511 1 16.2541 1.06859 16.1752 1.26574",
    fill: "url(#paint2_linear_0_3823)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_3823",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 1,
    width: 9,
    height: 17
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0657 1C21.7113 6.6594 20.3605 12.3051 19 17.9906H19.4053C20.7581 17.9906 22.1111 17.9765 23.4634 17.9997C23.8406 18.0063 23.9693 17.903 24.0461 17.5781C25.1517 12.9012 26.2738 8.22726 27.3916 3.55271C27.5937 2.70743 27.7946 1.86195 28 1H23.0657Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_3823)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0657 1C21.7113 6.6594 20.3605 12.3051 19 17.9906V17.9906H19.4053C20.7581 17.9906 22.1111 17.9765 23.4634 17.9997V17.9997C23.8406 18.0063 23.9693 17.903 24.0461 17.5781V17.5781C25.1517 12.9012 26.2738 8.22726 27.3916 3.55271V3.55271C27.5937 2.70743 27.7946 1.86195 28 1V1H23.0657Z",
    fill: "url(#paint3_linear_0_3823)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_3823",
    x1: 3.13785,
    y1: 37.2915,
    x2: 54.8692,
    y2: 36.9939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D439A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_3823",
    x1: 5.52811,
    y1: 43.5674,
    x2: 55.1695,
    y2: 43.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D439A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_3823",
    x1: 3.30463,
    y1: 30.5636,
    x2: 55.2782,
    y2: 30.0514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D439A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_3823",
    x1: 1.38494,
    y1: 63.5825,
    x2: 58.5122,
    y2: 63.4883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D439A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.c75e52d6dd2eb1104d54e6a0358fc72a.svg";
export { ForwardRef as ReactComponent };